import { createTheme } from '@mui/material/styles';

export default createTheme({
  typography: {
    fontFamily: 'nunito-sans',
  },
  palette: {
    primary: {
      main: '#184042',
      light: '#2e8a8f',
    },
    secondary: {
      main: '#d28736',
    },
    background: {
      default: 'white',
    },
  },
});
